module.exports = __webpack_public_path__ + "static/less-than-20-cents-295d57a2aadca005de916fb33513afac.png";